var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.current_match.status == -2
    ? _c("div", { staticClass: "fg-box football-details" }, [
        _c("div", { staticClass: "football-top-section" }, [
          _c("div", { staticClass: "teams" }, [
            _c("div", { staticClass: "team team-a" }, [
              _vm._v(_vm._s(_vm.h_team.name)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "scores" }, [
              _c("div", { staticClass: "score" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.h_team.score || 0) +
                      " - " +
                      _vm._s(_vm.a_team.score || 0)
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "team team-b" }, [
              _vm._v(_vm._s(_vm.a_team.name)),
            ]),
          ]),
          _vm._v(" "),
          _vm.allGoals && _vm.allGoals.length
            ? _c("div", { staticClass: "players" }, [
                _c(
                  "div",
                  { staticClass: "player player-a" },
                  _vm._l(_vm.matchGoals(false), function (mg) {
                    return _c("div", { key: mg.player_id }, [
                      _c("span", { staticClass: "goal_scorer" }, [
                        _vm._v(_vm._s(mg.display_name) + " "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "goal_details" }, [
                        _vm._v(_vm._s(mg.goal_details)),
                      ]),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "football-icon" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "player player-b" },
                  _vm._l(_vm.matchGoals(true), function (mg) {
                    return _c("div", { key: mg.player_id }, [
                      _c("span", { staticClass: "goal_scorer" }, [
                        _vm._v(_vm._s(mg.display_name) + " "),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "goal_details" }, [
                        _vm._v(_vm._s(mg.goal_details)),
                      ]),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "football-bottom-section" },
          _vm._l(_vm.events, function (evt, evt_idx) {
            return _c("div", { key: evt_idx, class: "evt_" + evt.event_id }, [
              _vm.isGoal(evt.event_id) && _vm.isAwayTeamEvent(evt.team_id)
                ? _c("div", { staticClass: "event-strip team_b_event" }, [
                    _c("div", { staticClass: "player player-lt" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "score" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.getMinuteBubble(evt.time))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "player player-rt" }, [
                      _c("span", [
                        _vm._v(_vm._s(evt.offensive_player.display_name)),
                      ]),
                      _vm._v(" "),
                      evt.score && evt.score.length
                        ? _c("span", [
                            _vm._v("\n            ("),
                            _c("span", [_vm._v(_vm._s(evt.score[0]))]),
                            _vm._v(" - "),
                            _c("span", [_vm._v(_vm._s(evt.score[1]))]),
                            _vm._v(")\n          "),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      evt.event_id == _vm.ownGoal
                        ? _c("div", { staticClass: "assist-by" }, [
                            _vm._v("Own goal"),
                          ])
                        : evt.event_id == _vm.penaltyGoal
                        ? _c("div", { staticClass: "assist-by" }, [
                            _vm._v("Penalty"),
                          ])
                        : evt.assisting_player
                        ? _c("div", { staticClass: "assist-by" }, [
                            _vm._v(
                              "Assist by " +
                                _vm._s(evt.assisting_player.player_name)
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", {
                        class: [
                          "icon football",
                          { red: evt.event_id == _vm.ownGoal },
                          { green: evt.event_id != _vm.ownGoal },
                        ],
                      }),
                    ]),
                  ])
                : _vm.isGoal(evt.event_id) && !_vm.isAwayTeamEvent(evt.team_id)
                ? _c("div", { staticClass: "event-strip team_a_event" }, [
                    _c("div", { staticClass: "player player-lt" }, [
                      _c("span", [
                        _vm._v(_vm._s(evt.offensive_player.display_name)),
                      ]),
                      _vm._v(" "),
                      evt.score && evt.score.length
                        ? _c("span", [
                            _vm._v("\n            ("),
                            _c("span", [_vm._v(_vm._s(evt.score[0]))]),
                            _vm._v(" - "),
                            _c("span", [_vm._v(_vm._s(evt.score[1]))]),
                            _vm._v(")\n          "),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      evt.event_id == _vm.ownGoal
                        ? _c("div", { staticClass: "assist-by" }, [
                            _vm._v("Own goal"),
                          ])
                        : evt.event_id == _vm.penaltyGoal
                        ? _c("div", { staticClass: "assist-by" }, [
                            _vm._v("Penalty"),
                          ])
                        : evt.assisting_player
                        ? _c("div", { staticClass: "assist-by" }, [
                            _vm._v(
                              "Assist by " +
                                _vm._s(evt.assisting_player.player_name)
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", {
                        class: [
                          "icon football",
                          { red: evt.event_id == _vm.ownGoal },
                          { green: evt.event_id != _vm.ownGoal },
                        ],
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "score" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.getMinuteBubble(evt.time))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "player player-rt" }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isSubstitute(evt.event_id) && _vm.isAwayTeamEvent(evt.team_id)
                ? _c("div", { staticClass: "event-strip team_b_event" }, [
                    _c("div", { staticClass: "player player-lt" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "score" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.getMinuteBubble(evt.time))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "player player-rt green" }, [
                      _c("span", [
                        _vm._v(_vm._s(evt.substitution.player_in.player_name)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "assist-by red" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(evt.substitution.player_out.player_name) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "icon arrows" }),
                    ]),
                  ])
                : _vm.isSubstitute(evt.event_id) &&
                  !_vm.isAwayTeamEvent(evt.team_id)
                ? _c("div", { staticClass: "event-strip team_a_event" }, [
                    _c("div", { staticClass: "player player-lt green" }, [
                      _c("span", [
                        _vm._v(_vm._s(evt.substitution.player_in.player_name)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "assist-by red" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(evt.substitution.player_out.player_name) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "icon arrows" }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "score" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.getMinuteBubble(evt.time))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "player player-rt" }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isCard(evt.event_id) && _vm.isAwayTeamEvent(evt.team_id)
                ? _c("div", { staticClass: "event-strip team_b_event" }, [
                    _c("div", { staticClass: "player player-lt" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "score" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.getMinuteBubble(evt.time))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "player player-rt" }, [
                      _c("span", [
                        _vm._v(_vm._s(evt.offensive_player.display_name)),
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        class: [
                          "icon card",
                          { red: evt.event_id == _vm.redCard },
                          { yellow: evt.event_id == _vm.yellowCard },
                        ],
                      }),
                    ]),
                  ])
                : _vm.isCard(evt.event_id) && !_vm.isAwayTeamEvent(evt.team_id)
                ? _c("div", { staticClass: "event-strip team_a_event" }, [
                    _c("div", { staticClass: "player player-lt" }, [
                      _c("span", [
                        _vm._v(_vm._s(evt.offensive_player.display_name)),
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        class: [
                          "icon card",
                          { red: evt.event_id == _vm.redCard },
                          { yellow: evt.event_id == _vm.yellowCard },
                        ],
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "score" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.getMinuteBubble(evt.time))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "player player-rt" }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isGameBreak(evt.event_id, evt.status_id)
                ? _c(
                    "div",
                    {
                      class: [
                        "time-img",
                        { half: _vm.ishalfTime(evt.status_id) },
                      ],
                    },
                    [
                      _c("div", { staticClass: "circle left" }),
                      _vm._v(" "),
                      _vm.ishalfTime(evt.status_id)
                        ? _c("div", { staticClass: "circle right" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.breakName[evt.status_id])),
                      ]),
                    ]
                  )
                : _vm._e(),
            ])
          }),
          0
        ),
      ])
    : _c("div", { staticClass: "fg-box football-details" }, [
        _c(
          "div",
          { staticClass: "table-responsive table-scoreboard points-table" },
          [
            _c("table", { staticClass: "table squad" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.h_team.name)),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.a_team.name)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.squads && _vm.squads.length
                ? _c(
                    "tbody",
                    _vm._l(_vm.squads, function (tr, tr_idx) {
                      return _c("tr", { key: tr_idx }, [
                        _c("td", { staticClass: "text-center" }, [
                          _vm._v(_vm._s(tr.t1)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center" }, [
                          _vm._v(_vm._s(tr.t2)),
                        ]),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }